import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconCopy, IconTrashX } from '@tabler/icons';
import { FC } from 'react';
import { UseListStateHandlers } from '@mantine/hooks';
import { QuestionnaireTemplateDto } from '../../../Types/QuestionnaireT';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import { QuestionnaireTemplateS } from '../../../Service/QuestionnaireTemplateS';

interface Props {
  index: number;
  template: QuestionnaireTemplateDto;
  handlers: UseListStateHandlers<QuestionnaireTemplateDto>;
}

const QuestionnaireTemplateActions: FC<Props> = ({ index, template, handlers }) => {
  const { id, name } = template;
  const { append, remove } = handlers;

  const duplicateTemplate = async () => {
    const copy = await QuestionnaireTemplateS.copyTemplate(name);
    if (copy) {
      append(copy);
    }
  };

  const deleteTemplate = async () => {
    openDeleteConfirmModal({
      title: 'Fragebogen löschen?',
      description: 'Möchtest Du wirklich diesen Fragebogen löschen?',
      onConfirm: async () => {
        const removed = await QuestionnaireTemplateS.deleteTemplate(id);
        if (removed) {
          remove(index);
        }
        return removed;
      },
    });
  };

  return (
    <Menu radius="md" shadow="md" width={150} transition="slide-down" position="bottom-end">
      <Menu.Target>
        <ActionIcon size="sm">
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconCopy size={16} />} onClick={duplicateTemplate}>
          Duplizieren
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={deleteTemplate}>
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default QuestionnaireTemplateActions;
